import posthog from "posthog-js";

function posthogConfig(): { key: string; host: string } {
  const w = typeof window !== "undefined" ? window.__ATS_PUBLIC__ : undefined;
  const env = typeof import.meta !== "undefined" ? import.meta.env ?? {} : {};
  const key =
    (w?.posthogKey?.trim() || env.VITE_POSTHOG_KEY || "phc_placeholder").trim();
  const host =
    (w?.posthogHost?.trim() || env.VITE_POSTHOG_HOST || "https://eu.i.posthog.com").trim();
  return { key, host };
}

const { key: POSTHOG_KEY, host: POSTHOG_HOST } = posthogConfig();

function isAnalyticsOptIn(): boolean {
  try {
    const raw = localStorage.getItem('atsmycv_settings_v1');
    if (!raw) return true; // default true
    const parsed = JSON.parse(raw) as { analyticsOptIn?: boolean };
    return parsed.analyticsOptIn !== false;
  } catch {
    return true;
  }
}

if (typeof window !== "undefined" && POSTHOG_KEY !== "phc_placeholder" && isAnalyticsOptIn()) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: '2026-01-30',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    person_profiles: "identified_only",
  });
}

export const analytics = posthog;

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (typeof window !== "undefined") {
    posthog.identify(userId, properties);
  }
}

export function resetUser() {
  if (typeof window !== "undefined") {
    posthog.reset();
  }
}

export function captureEvent(event: string, properties?: Record<string, unknown>) {
  if (typeof window !== "undefined") {
    posthog.capture(event, properties);
  }
}
